import { render, staticRenderFns } from "./salesReturnAction.vue?vue&type=template&id=2b332ae2&scoped=true"
import script from "./salesReturnAction.vue?vue&type=script&lang=js"
export * from "./salesReturnAction.vue?vue&type=script&lang=js"
import style0 from "./salesReturnAction.vue?vue&type=style&index=0&id=2b332ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b332ae2",
  null
  
)

export default component.exports